import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const post_RechargeWallet = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirWallet/Recharge`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getWalletByTenantId = (tenantId: number) => {
    return getFetch(`mycdirWallet/GetMycdirWalletByTenantId/${tenantId}`)
}

const getFetch = async (url: string, params = {}) => {
    return await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params,
    }).then(response => response.data);
}
